import { Dimensions } from 'react-native';

const { height: SCREEN_HEIGHT, width: SCREEN_WIDTH } = Dimensions.get('window');

// Layout Constants
export const HERO_HEIGHT_RATIO = 0.4;
export const HERO_HEIGHT = Math.round(SCREEN_HEIGHT * HERO_HEIGHT_RATIO);
export { SCREEN_WIDTH };

// Border Radius
export const CARD_BORDER_RADIUS = 24;
export const PHOTO_BORDER_RADIUS = 12;

// Spacing
export const CARD_MARGIN_TOP = -60;
export const CARD_PADDING = 20;
export const SECTION_GAP = '$6';
export const ITEM_GAP = '$2';
export const ACTIONS_BAR_OVERLAP = -55;
export const BOTTOM_PADDING = 90;

// Photo Gallery
export const LOCKED_PHOTO_HEIGHT = 350;

// Icon Sizes
export const ICON_SIZE_SMALL = 16;
export const ICON_SIZE_MEDIUM = 18;
export const ICON_SIZE_LARGE = 32;
export const ICON_SIZE_XLARGE = 28;

// Font Sizes
export const FONT_SIZE_TITLE = 32;
export const FONT_SIZE_SECTION = 16;

